var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareScreenActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 5C3.37772 5 2.90081 5.19753 2.54917 5.54914C2.19754 5.90076 2 6.37764 2 6.8749V18.1243C1.99989 18.3706 2.04831 18.6144 2.14249 18.842C2.23667 19.0696 2.37476 19.2764 2.54888 19.4506C2.723 19.6247 2.92974 19.7629 3.15728 19.8572C3.38482 19.9515 3.6287 20 3.875 20H20.125C20.6223 20 21.0992 19.8025 21.4508 19.4509C21.8025 19.0992 22 18.6224 22 18.1251V6.87573C22 6.37848 21.8025 5.90159 21.4508 5.54998C21.0992 5.19837 20.6223 5.00083 20.125 5.00083L3.875 5ZM12.44 8.20066L15.1525 10.913C15.2663 11.0309 15.3292 11.1888 15.3277 11.3527C15.3262 11.5166 15.2604 11.6733 15.1445 11.7891C15.0285 11.9049 14.8718 11.9706 14.7079 11.9719C14.544 11.9733 14.3862 11.9102 14.2683 11.7963L12.6233 10.1514V16.3569C12.6233 16.5226 12.5575 16.6816 12.4403 16.7988C12.3231 16.916 12.1641 16.9818 11.9983 16.9818C11.8326 16.9818 11.6736 16.916 11.5564 16.7988C11.4392 16.6816 11.3733 16.5226 11.3733 16.3569V10.153L9.73167 11.7963C9.67404 11.856 9.6051 11.9036 9.52886 11.9364C9.45262 11.9692 9.37062 11.9865 9.28763 11.9873C9.20465 11.988 9.12234 11.9723 9.04552 11.9409C8.96869 11.9095 8.89889 11.8631 8.84018 11.8045C8.78147 11.7458 8.73503 11.676 8.70356 11.5993C8.6721 11.5225 8.65625 11.4402 8.65693 11.3572C8.65761 11.2742 8.67481 11.1922 8.70753 11.1159C8.74025 11.0397 8.78783 10.9707 8.8475 10.913L11.5558 8.20149C11.6139 8.14341 11.6828 8.09734 11.7586 8.06591C11.8345 8.03448 11.9158 8.0183 11.9979 8.0183C12.08 8.0183 12.1613 8.03448 12.2372 8.06591C12.313 8.09734 12.382 8.14258 12.44 8.20066Z",
    fill: "url(#paint0_linear_33_17)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_17",
    x1: 2,
    y1: 5,
    x2: 16.4,
    y2: 24.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9B4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenActive);
export default __webpack_public_path__ + "static/media/share-screen-active.491d00873f986fca18219a2a7c39ca87.svg";
export { ForwardRef as ReactComponent };